const COMMIT_COMPARE_ERRORS_ENUM = {
    'com.gitflic.core.exception.CommitNotFoundException.title' : 'Один из сравниваемых коммитов не найден!',
    'java.lang.IllegalArgumentException.title' : 'Некорректный ввод!'
};

export default { COMMIT_COMPARE_ERRORS_ENUM };